import {createApi} from '@reduxjs/toolkit/dist/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {getBaseURL} from 'src/utils/helper';
import {
    GuestConnectorDTO,
    GuestSessionDTO,
    GuestSessionFullDTO,
    CreateGuestSessionRequest,
    SendGuestReceiptRequest,
} from 'src/types/guest';

export const guestApi = createApi({
    reducerPath: 'guestApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/public/guest'),
    }),
    tagTypes: ['GuestSession'],
    endpoints: (build) => ({
        // GET /api/public/guest/connector/{uuid}
        getGuestConnector: build.query<GuestConnectorDTO, string>({
            query: (uuid) => ({
                url: `/connector/${uuid}`,
                method: 'get',
            }),
        }),

        // POST /api/public/guest/session
        createGuestSession: build.mutation<GuestSessionDTO, CreateGuestSessionRequest>({
            query: (data) => ({
                url: '/session',
                method: 'post',
                data,
            }),
            invalidatesTags: ['GuestSession'],
        }),

        // GET /api/public/guest/session/{uuid}
        getGuestSession: build.query<GuestSessionFullDTO, string>({
            query: (uuid) => ({
                url: `/session/${uuid}`,
                method: 'get',
            }),
            providesTags: ['GuestSession'],
        }),

        // POST /api/public/guest/session/{uuid}/start
        startGuestCharging: build.mutation<GuestSessionFullDTO, string>({
            query: (uuid) => ({
                url: `/session/${uuid}/start`,
                method: 'post',
            }),
            invalidatesTags: ['GuestSession'],
        }),

        // POST /api/public/guest/session/{uuid}/receipt
        sendGuestReceipt: build.mutation<GuestSessionFullDTO, SendGuestReceiptRequest>({
            query: ({uuid, ...data}) => ({
                url: `/session/${uuid}/receipt`,
                method: 'post',
                data,
            }),
            invalidatesTags: ['GuestSession'],
        }),

        // POST /api/public/guest/session/{uuid}/stop
        stopGuestCharging: build.mutation<GuestSessionFullDTO, string>({
            query: (uuid) => ({
                url: `/session/${uuid}/stop`,
                method: 'post',
            }),
            invalidatesTags: ['GuestSession'],
        }),
    }),
});

export const {
    useGetGuestConnectorQuery,
    useLazyGetGuestConnectorQuery,
    useCreateGuestSessionMutation,
    useGetGuestSessionQuery,
    useLazyGetGuestSessionQuery,
    useStartGuestChargingMutation,
    useStopGuestChargingMutation,
    useSendGuestReceiptMutation,
} = guestApi;
